import { $ } from './element';

const nativeFocusableTags = ['input', 'textarea', '*[tabindex]', '*[contenteditable]', 'button', 'a'];
const webComponentsFocusableTags = ['ins-input', 'ins-textarea', 'ins-select', 'ins-checkbox', 'ins-datepicker'];

export function focusable(element: any): { element: HTMLElement, focusMethodName: string } {
    if (element?.setFocus) {
        return { element, focusMethodName: 'setFocus' };
    }

    const focusableElem = allFocusable(element)[0];
    return {
        element: focusableElem,
        focusMethodName: webComponentsFocusableTags.includes(focusableElem?.tagName.toLowerCase()) ? 'setFocus' : 'focus'
    };
}

export function allFocusable(element: HTMLElement): HTMLElement[] {
    const focusableTarget = [...webComponentsFocusableTags, ...nativeFocusableTags].join(', ') ;
    return $(element)
        .findAll(focusableTarget)
        .map(el => el.element)
        .filter(el => !isNotFocusable(el));
}

export function isNotFocusable(element: HTMLElement): boolean {
    const notFocusableTarget = '[tabindex="-1"], [disabled], ins-panel';
    return $(element).is(notFocusableTarget)
            || ((element as unknown as HTMLInsInputElement)?.validation?.readonly || (element as unknown as HTMLInsInputElement)?.disabled)
            || !$(element).isVisible();
}
